import { ChevronDown, ChevronUp } from 'lucide-react';

export interface AccordionProps {
  id?: string;
  isOpen: boolean;
  title: string;
  onToggle: () => void;
  children: React.ReactNode;
}

const Accordion = ({
  title,
  children,
  isOpen,
  onToggle,
  id,
}: AccordionProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm mb-4" id={id}>
      <div
        className="flex justify-between items-center p-4 cursor-pointer"
        onClick={onToggle}
      >
        <span className="text-base text-[#333333] font-semibold">{title}</span>
        <div className="text-gdt-blue">
          {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </div>
      </div>
      {isOpen && (
        <div className="border-t border-gdt-gray-5 p-4">{children}</div>
      )}
    </div>
  );
};

export default Accordion;
